import React, { useState, useEffect } from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
  Typography,
  IconButton,
} from '@mui/material'
import { authedAxios } from '../../utils'
import { useParams } from 'react-router-dom'
import CustomerSearch from '../../common/CustomerSearch'

import { Close } from '@mui/icons-material'

const TaskModal = ({
  contact,
  isOpen,
  setIsOpen,
  customer: customerProp,
  onSave,
  taskType: taskTypeProp,
}) => {
  const [contactId, setContactId] = useState('')
  const [taskType, setTaskType] = useState(1)
  const [date, setDate] = useState(new Date().toLocaleDateString('sv'))
  const [note, setNote] = useState('')
  const [contacts, setContacts] = useState([])
  const [error, setError] = useState(false)
  const [taskTypes, setTaskTypes] = useState([])

  const [customerSearchValue, setCustomerSearchValue] = useState(null)
  const [customer, setCustomer] = useState(customerProp)
  const [customerSearchQuery, setCustomerSearchQuery] = useState('')

  const onSelectCustomer = (customer) => {
    setCustomer(customer)
  }

  const { id: customerId } = useParams()

  const cid = customer?.id || customerId

  useEffect(() => {
    if (contact) setContactId(contact.id)
  }, [contact])

  useEffect(() => {
    if (taskTypeProp) setTaskType(taskTypeProp.id)
  }, [taskTypeProp])

  const handleClose = () => setIsOpen(false)

  const handleSubmit = () => {
    if (!(date && cid)) return

    const task = {
      note,
      date: new Date(date),
      customerContactId: contactId || undefined,
      taskTypeId: taskType,
      customerId: cid,
    }

    authedAxios
      .post('/api/task', task)
      .then((res) => {
        if (onSave) onSave(res.data.task)
        setIsOpen(false)
      })
      .catch((e) => {
        setError(true)
      })
  }

  const getContacts = () => {
    if (!cid) return
    authedAxios
      .get(`/api/customer/${cid}/contact`)
      .then((res) => {
        setContacts(res.data.contacts)
      })
      .catch(() => setError(true))
  }

  const getTaskTypes = () => {
    authedAxios
      .get('/api/task/types')
      .then((res) => {
        setTaskTypes(res.data.types)
      })
      .catch(() => setError(true))
  }

  useEffect(() => {
    if (!isOpen) return
    getTaskTypes()
  }, [isOpen])

  useEffect(() => {
    if (!isOpen) return
    getContacts()
  }, [isOpen, customerId, customer])

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'sm'}>
      <DialogTitle>Schedule Task</DialogTitle>
      <DialogContent sx={{ paddingTop: '20px !important' }}>
        {!customer && (
          <CustomerSearch
            margin={'dense'}
            // value={customerSearchValue}
            onSelect={onSelectCustomer}
            allowAdd={false}
            searchQuery={customerSearchQuery}
            setSearchQuery={setCustomerSearchQuery}
          />
        )}
        {customer && (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography>
                Account: <b>{customer.name}</b>
              </Typography>
              <IconButton onClick={() => setCustomer(null)}>
                <Close />
              </IconButton>
            </Box>

            <TextField
              margin='dense'
              fullWidth
              label='Contact'
              value={contactId}
              onChange={(e) => setContactId(e.target.value)}
              select
            >
              {contacts.length === 0 && (
                <MenuItem disabled>No contacts found</MenuItem>
              )}
              {contacts.map((c, i) => (
                <MenuItem key={i} value={c.id}>
                  {`${c.firstName} ${c.lastName}`}
                </MenuItem>
              ))}
            </TextField>
          </>
        )}
        <TextField
          margin='dense'
          fullWidth
          label='Task type'
          value={taskType}
          onChange={(e) => setTaskType(e.target.value)}
          select
        >
          {taskTypes.map((c, i) => (
            <MenuItem key={i} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label={'Date'}
          type={'date'}
          margin='dense'
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          value={date}
          onChange={(e) => {
            setDate(e.target.value)
          }}
        ></TextField>

        <TextField
          onChange={(e) => setNote(e.target.value)}
          value={note}
          margin='dense'
          label={'Note'}
          fullWidth
          multiline
          rows={4}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} color={'primary'} variant={'contained'}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TaskModal
